// client/src/components/common/NotificationBadge.js
import React from 'react'
import './NotificationBadge.css'

/**
 * NotificationBadge component - displays unread notification count
 * Shows a red dot for 1-9 notifications, or a count badge for 10+
 * Clean, minimal design that doesn't distract from navigation
 * 
 * @param {number} count - Number of unread notifications
 * @param {boolean} loading - Loading state
 */
function NotificationBadge({ count = 0, loading = false }) {
  // Don't show anything if no unread notifications or still loading
  if (loading || count === 0) {
    return null
  }

  // For small counts (1-9), show a simple red dot
  // For larger counts (10+), show the actual number
  const showCount = count >= 10
  const displayCount = count > 99 ? '99+' : count

  return (
    <span
      className={`notification-badge ${showCount ? 'notification-badge--count' : 'notification-badge--dot'}`}
      aria-label={`${count} unread notification${count === 1 ? '' : 's'}`}
      data-testid="notification-badge"
    >
      {showCount ? displayCount : null}
    </span>
  )
}

export default NotificationBadge
